import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { AiccLanguageStatus } from "constants/aiccLanguage";
import { AiccLanguageName } from "types/model/aiccLearningAssets";

interface LearningAssetsState {
  languages: AiccLanguageName[];
  languageId?: number;
  activeStatus?: AiccLanguageStatus;
  selectedLevels: number[];
  selectedLessons: number[];
  setLanguages: (languages: AiccLanguageName[]) => void;
  setLanguageId: (languageId: number) => void;
  setActiveStatus: (activeStatus: AiccLanguageStatus) => void;
  setSelectedLevels: (selectedLevels: number[]) => void;
  setSelectedLessons: (selectedLessons: number[]) => void;
}

export const useLearningAssetsStore = create<LearningAssetsState>()(
  persist(
    (set) => ({
      languages: [],
      selectedLevels: [],
      selectedLessons: [],
      setLanguages: (languages) => set({ languages }),
      setLanguageId: (languageId) =>
        set((state) =>
          state.languageId === languageId ? { languageId } : { languageId, selectedLevels: [], selectedLessons: [] }
        ),
      setActiveStatus: (activeStatus) => set({ activeStatus }),
      setSelectedLevels: (selectedLevels) => set({ selectedLevels }),
      setSelectedLessons: (selectedLessons) => set({ selectedLessons }),
    }),
    {
      name: "aicc-learning-assets",
      storage: createJSONStorage(() => sessionStorage),
      partialize: ({ languageId, activeStatus, selectedLevels, selectedLessons }) => ({
        languageId,
        activeStatus,
        selectedLevels,
        selectedLessons,
      }),
    }
  )
);
